import React from 'react';
import { BsRecordFill } from 'react-icons/bs';
import { HStack, Icon, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { Statuses } from '../../../../constants/statuses';
import colors from '../../../../styles/theme/foundation/colors';

function BooleanPolicyProperties({ displayName, expired }) {
  const textColors = expired
    ? { icon: colors.error.primary['600'], text: colors.greyScale['800'] }
    : { icon: colors.primaryScale['600'], text: colors.greyScale['900'] };

  return (
    <HStack alignItems="flex-start" mt={2}>
      <Icon
        as={BsRecordFill}
        boxSize="10px"
        color={textColors.icon}
        mt="5px"
      />
      <Text
        color={textColors.text}
        textStyle="bodySm500"
      >
        {displayName}
      </Text>
    </HStack>
  );
}

BooleanPolicyProperties.propTypes = {
  displayName: PropTypes.string,
  expired: PropTypes.bool
};

export default BooleanPolicyProperties;
